import * as React from 'react';
import './WelcomeComponent.css';

import {t} from 'react-multi-lang';
import {IWelcomeProps} from "../../containers/WelcomeContainer";

class WelcomeComponent extends React.PureComponent<IWelcomeProps> {
    constructor(props: IWelcomeProps) {
        super(props);

        this.importClickAction = this.importClickAction.bind(this);
    }

    public render() {
        return (
            <>
                <div className="w_header">{t('welcome.welcome')}</div>
                <div className="w_component w_component_fill">
                <span>
                    {t('welcome.instructions')}
                    <button className={"btn btn-secondary btn-sm btn-info ml-2 mr-2"} title={t('welcome.hover')}
                            onClick={this.importClickAction}>
                        {t('import.import')}
                    </button>
                </span>
                </div>
            </>
        );
    }

    private importClickAction() {
        this.props.history.push(`/import`);
    }
}

export default WelcomeComponent;


// WEBPACK FOOTER //
// ./src/components/WelcomeComponent/WelcomeComponent.tsx